export const screenWidthContainerMetaData = {
    fullWidth: true
}
